import ProductMultipleVariantsForm from './ModuleProductMultipleVariantsForm';

export default class{
  /**
   *
   * @param {HTMLElement} htmlElement
   */

  constructor(htmlElement) {
    this.view = htmlElement;
    new CardProductFlip(this.view);

    Array.prototype.slice.call(
      this.view.querySelectorAll('.product-multiple-variants-form')
    ).forEach(x => new ProductMultipleVariantsForm(x));

  }
}

class CardProductFlip{
  /**
   *
   * @param {HTMLElement} htmlElement
   */
  constructor(htmlElement){
    this.view = htmlElement;
    this.view.querySelector('.card-product-more-info').addEventListener('click', e => this.flipToBack(e));
    this.view.querySelector('.card-product-close').addEventListener('click', e => this.flipToFront(e));
  }

  /**
   *
   * @param {Event} e
   */
  flipToBack(e){
    e.preventDefault();
    if(!this.view.classList.contains('card-product-is-flipped') ){
      this.view.classList.add('card-product-is-flipped');
    }
  }

  /**
   *
   * @param {Event} e
   */
  flipToFront(e){
    if(this.view.classList.contains('card-product-is-flipped') ){
      this.view.classList.remove('card-product-is-flipped');
    }
  }
}